import { FC, ReactNode, useCallback, useMemo, useState } from 'react';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material';
import { ThemeProvider as JssThemeProvider } from 'react-jss';
import CssBaseline from '@mui/material/CssBaseline';
import {
  AppThemeContext,
  DEFAULT_THEME,
  getThemeName,
  setThemeName as persistThemeName,
  THEMES,
  ThemeName,
} from './helpers';

interface Props {
  children: ReactNode;
}

export const AppThemeProvider: FC<Props> = ({ children }) => {
  const [themeName, setThemeName] = useState<ThemeName>(getThemeName() ?? DEFAULT_THEME);

  const handleSetThemeName = useCallback((name: ThemeName) => {
    setThemeName(name);
    persistThemeName(name);
  }, []);

  const activeTheme = useMemo(() => createTheme(THEMES[themeName]), [themeName]);

  return (
    <AppThemeContext.Provider value={{ themeName, setThemeName: handleSetThemeName }}>
      <MuiThemeProvider theme={activeTheme}>
        <CssBaseline />
        <JssThemeProvider theme={activeTheme}>{children}</JssThemeProvider>
      </MuiThemeProvider>
    </AppThemeContext.Provider>
  );
};
